import { render, staticRenderFns } from "./RecordType.vue?vue&type=template&id=538366ea&scoped=true&"
import script from "./RecordType.vue?vue&type=script&lang=js&"
export * from "./RecordType.vue?vue&type=script&lang=js&"
import style0 from "./RecordType.vue?vue&type=style&index=0&id=538366ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538366ea",
  null
  
)

export default component.exports